import PropTypes from "prop-types";

export default {
	isRight: PropTypes.bool,
};
